import { HttpParams } from '@angular/common/http';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { KieneAutocompleteComponent } from '../../../../../../../../src/app/components/kiene-autocomplete/kiene-autocomplete.component';
import { API_BASE_URL_SERVICE } from '../../../../kiene-core.config';
import { AppService } from '../../../../services/app/app.service';
import { KieneBackendApiService } from '../../../../services/backend-api/kiene-backend-api.service';
import { MessageService } from '../../../../services/message-service/message.service';
import { Client } from '../../../client/classes/client';
import { ConfirmDialogInput } from '../../../dialogs/confirm-dialog/confirm-dialog';
import { ConfirmDialogComponent } from '../../../dialogs/confirm-dialog/confirm-dialog.component';
import {
    MeineKontakteDialogInput,
    MeineKontakteDialogResult,
} from '../../../meine-kontakte/meine-kontakte-dialog/meine-kontakte-dialog';
import { MeineKontakteDialogComponent } from '../../../meine-kontakte/meine-kontakte-dialog/meine-kontakte-dialog.component';
import { Betriebsart, Produktionsabschnitt } from '../../../stammdaten/vvvo/classes/betriebsart';
import { Gruppe } from '../../classes/gruppe';
import { GruppeSchweinDialogInput } from './gruppe-schweine-dialog';

@Component({
    selector: 'kiene-gruppe-schweine-dialog',
    templateUrl: './gruppe-schweine-dialog.component.html',
    styleUrls: ['./gruppe-schweine-dialog.component.scss'],
})
export class GruppeSchweineDialogComponent implements OnInit {
    @ViewChild('standortAutocomplete')
    standortAutocomplete: KieneAutocompleteComponent;

    params = new HttpParams();

    gruppennameCtrl = new FormControl(undefined, [Validators.required]);
    anzahlTiereCtrl = new FormControl(undefined, [Validators.required]);

    einstalldatumVonCtrl = new FormControl(undefined, [Validators.required]);
    einstallgewichtProTierCtrl = new FormControl();
    abteilCtrl = new FormControl();
    stall: string;

    produktionsabschnittCtrl = new FormControl<Produktionsabschnitt>(undefined, [Validators.required]);
    produktionsabschnitte: Produktionsabschnitt[] = [];
    produktionsabschnittSub: Subscription;

    kundeHerkunft: Client;
    isSaving = false;
    isMobile = false;

    constructor(
        public dialogRef: MatDialogRef<GruppeSchweineDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public input: GruppeSchweinDialogInput,
        @Inject(API_BASE_URL_SERVICE) public apiBaseUrl: string,
        private dialog: MatDialog,
        private api: KieneBackendApiService,
        private appService: AppService,
        private messageService: MessageService,
    ) {}

    showAnzahlDatumGewicht(): boolean {
        return this.input.showAnzahlDatumGewicht;
    }

    showAbschnittStallAbteil(): boolean {
        return !this.input?.gruppe?.gruppe_id;
    }

    ngOnInit(): void {
        this.isMobile = this.appService.isMobileScreen;
        this.gruppennameCtrl.setValue(this.input?.gruppe?.bezeichnung, { emitEvent: false });
        this.anzahlTiereCtrl.setValue(this.input?.gruppe?.anzahl_tiere_aktuell, { emitEvent: false });

        // TODO:
        //if (this.input?.produktionsabschnitt) {
        //    this.produktionsabschnittCtrl.setValue(this.input.produktionsabschnitt);
        //}

        this.abteilCtrl.setValue(this.input?.gruppe?.abteil, { emitEvent: false });
        this.stall = this.input?.gruppe?.stall;

        this.einstalldatumVonCtrl.setValue(this.input?.gruppe?.einstalldatum_von, { emitEvent: false });
        this.einstallgewichtProTierCtrl.setValue(this.input?.gruppe?.einstall_gewicht, { emitEvent: false });

        if (this.input?.kunde_id) {
            this.params = this.params.set('kunde_id', this.input?.kunde_id);
            this.loadGruppennamenUndAufstalleinheitVorschlag();
            this.ladeProduktionsabschnitte();
        } else {
            this.messageService.alertMessage('Es wurde kein Kunde übergeben!');
        }

        if (this.input?.gruppe?.kunde_id_herkunft) {
            this.ladeHerkunftsBetrieb();
        }

        this.ladeProduktionsabschnitte();
    }

    ladeProduktionsabschnitte() {
        if (this.input?.betriebsart_id) {
            this.produktionsabschnittSub?.unsubscribe();
            this.produktionsabschnittSub = this.api
                .getByIdAlternative(
                    this.apiBaseUrl + 'betriebsart/read_one.php',
                    'betriebsart_id',
                    this.input?.betriebsart_id,
                )
                .subscribe({
                    next: (betriebsart: Betriebsart) => {
                        this.produktionsabschnitte = betriebsart.produktionsabschnitte;
                        const existingAbschnittId = this.input?.gruppe?.produktionsabschnitt_id;
                        if (existingAbschnittId) {
                            const existing = this.produktionsabschnitte.find(
                                p => p.produktionsabschnitt_id === existingAbschnittId,
                            );
                            if (existing) {
                                this.produktionsabschnittCtrl.setValue(existing, { emitEvent: false });
                                return;
                            }
                        }
                        if (this.produktionsabschnitte?.length === 1) {
                            this.produktionsabschnittCtrl.setValue(this.produktionsabschnitte[0]);
                        }
                    },
                    error: err => {
                        this.messageService.errorMessage('Produktionsabschnitte konnten nicht geladen werden!', err);
                    },
                });
        }
    }

    produktionsabschnittComparator(a: Produktionsabschnitt, b: Produktionsabschnitt): boolean {
        return a?.produktionsabschnitt_id === b?.produktionsabschnitt_id;
    }

    ladeHerkunftsBetrieb() {
        const params = new HttpParams().set('kunde_id', this.input?.gruppe?.kunde_id_herkunft);
        this.api.get(this.apiBaseUrl + 'kunde/read_one.php', params).subscribe({
            next: response => {
                if (response) {
                    this.kundeHerkunft = <Client>response;
                }
            },
            error: error => {
                this.messageService.errorMessage('Herkunfts Betrieb konnte nicht geladen werden!', error);
            },
        });
    }

    loadGruppennamenUndAufstalleinheitVorschlag() {
        if (!this.input?.gruppe?.bezeichnung && this.input?.kunde_id) {
            this.api
                .getByIdAlternative(this.apiBaseUrl + 'gruppe/read_vorschlag.php', 'kunde_id', this.input?.kunde_id)
                .subscribe(response => {
                    if (response) {
                        this.gruppennameCtrl.setValue(response?.bezeichnung);
                    }
                });
        }
    }

    setStandort(standort) {
        if (typeof standort === 'object' && standort?.stall) {
            this.stall = standort.stall;
        } else if (typeof standort === 'string' && standort) {
            this.stall = standort;
        } else {
            console.log(standort);
        }
    }

    deleteStall(gruppe: Gruppe) {
        const input = new ConfirmDialogInput();
        input.headline = 'Stall löschen';
        input.text = 'Wollen Sie den Stall wirklich löschen?';

        this.dialog
            .open(ConfirmDialogComponent, { data: input })
            .afterClosed()
            .subscribe({
                next: result => {
                    if (result.ok) {
                        this.deleteStallConfirmed(gruppe);
                    }
                },
            });
    }

    close() {
        this.dialogRef.close();
    }

    save() {
        this.isSaving = true;
        const gruppe = new Gruppe();
        gruppe.gruppe_id = this.input?.gruppe?.gruppe_id; // null beim Erstellen
        gruppe.kunde_id = this.input?.kunde_id;
        gruppe.kunde_id_herkunft = this.kundeHerkunft?.kunde_id;
        gruppe.produktionsabschnitt_id =
            this.produktionsabschnittCtrl.value?.produktionsabschnitt_id ??
            this.input?.gruppe?.produktionsabschnitt_id;
        gruppe.abteil = this.abteilCtrl.value;
        gruppe.zugang_melden = 0;
        gruppe.stall = this.stall;
        gruppe.bezeichnung = this.gruppennameCtrl.value;
        gruppe.einstalldatum_von = this.einstalldatumVonCtrl.value;
        gruppe.einstall_gewicht = this.einstallgewichtProTierCtrl.value;
        gruppe.anzahl_tiere = this.anzahlTiereCtrl.value;

        this.api.post(this.apiBaseUrl + 'gruppe/update_schwein.php', gruppe).subscribe({
            next: response => {
                const gruppe = <Gruppe>response;
                this.messageService.infoMessage('Die Gruppe wurde erfolgreich angelegt!');
                this.isSaving = false;
                this.dialogRef.close(gruppe);
            },
            error: error => {
                this.isSaving = false;
                this.messageService.errorMessage('Die Gruppe konnte nicht angelegt werden!', error);
            },
        });
    }
    // TODO: bearbeiten, nicht so ganz sauber
    public isFormValid(): boolean {
        const produktionsabschnittOk = this.showAbschnittStallAbteil()
            ? this.produktionsabschnittCtrl.valid
            : this.produktionsabschnittCtrl.valid || !!this.input?.gruppe?.produktionsabschnitt_id;
        return (
            produktionsabschnittOk &&
            this.gruppennameCtrl.valid &&
            (this.showAbschnittStallAbteil() ? !!this.stall : true) &&
            this.einstalldatumVonCtrl.valid &&
            this.anzahlTiereCtrl.valid &&
            !this.isSaving
        );
    }

    public openHerkunftsBetriebDialog(): void {
        let input = new MeineKontakteDialogInput('Herkunftsbetrieb', false, true, false, this.input?.kunde_id);

        this.dialog
            .open(MeineKontakteDialogComponent, { data: input })
            .afterClosed()
            .subscribe({
                next: (result: MeineKontakteDialogResult) => {
                    if (result?.kunde) {
                        this.kundeHerkunft = result.kunde;
                    }
                },
            });
    }

    deleteHerkunftsbetrieb() {
        this.kundeHerkunft = null;
    }

    private deleteStallConfirmed(gruppe: Gruppe): void {
        this.api.deleteGeneric(this.apiBaseUrl + 'gruppe/delete_stall.php', gruppe).subscribe({
            next: () => {
                this.messageService.infoMessage('Der Standort wurde erfolgreich gelöscht!');
                this.standortAutocomplete.clearAndFocus();
            },
            error: error => {
                this.messageService.errorMessage('Der Standort konnte nicht gelöscht werden', error);
            },
        });
    }
}
